interface Store {
  id: number
  pluginspaceId: number
  link: string
  description: string
  code: string
  status: boolean
  paymentIntegrated: boolean
  created: string
  updated: string
  order: number
  img: string | null

  // campos do pluginspace
  name: string
  cnpj: string
  type: string
  pluginspace?: Pluginspace
}

interface Pluginspace {
  id: number
  name: string
  corporateName: string
  cnpj: string
  hash: string
  subdomain: string
  type: string
  imageLogin: string | null
  permission: any | null
  content: {
    theme: {
      admin: string
      logo: string
    }
  }
  skinId: number
  image: string | null
  terms: boolean
  appLogin: boolean
  gmt: string
  translate: boolean
  createdUserId: number
  confirmationDateTime: string | null
  confirmationHash: string | null
  status: boolean
  created: string
  updated: string
  deleted: string | null
  removed: number
  parent: number
  storeCode: string
  defaultLanguage: string
  lead: number
  category: string | null
  defaultCurrency: string
  resaleId: number | null
  resellerId: number | null
  emailContact: string | null
  phoneContact: string | null
  wholeSaler: boolean
}


enum sectionType {
    category = "category",
    content = "content",
    simple = "simple",
    form = "form",
    page = "page",
}

type SectionItem = {
    id?: number
    itemId: number
    itemType: sectionType
    order: number
}

// ✅ ATUALIZADO - SectionData agora suporta items array
type SectionData = {
    id?: number
    title: string
    svgId: string
    svg?: {
        id: string
        svg: string
    }
    type: sectionType
    status: boolean
    
    // ⚠️ DEPRECATED - mantido para backward compatibility
    itemId?: number
    
    // ✅ NOVO - array de items para múltiplas lojas
    items?: SectionItem[]
    
    created_at?: string
    updated_at?: string
}

type CategoryType = {
    id: number;
    name: string;
    status: boolean;
    code: string;
}

type IconType = {
    id: number;
    svg: string;
    description: string;
    category: string;
}


export { sectionType }
export type { Store, Pluginspace, SectionData,SectionItem, CategoryType, IconType }
